module.exports = __webpack_public_path__ + "img/location.5a9e0255.png";